import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo, CampoNumero } from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';
import { Garanzia } from './Garanzia';
import { Prodotto } from './Prodotto';
import { SemaforoVerde } from '../DatiRCP';


interface IProdottiProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON
    Abilitato?: boolean;
    CampoPreventivoSelezionato: string;
    Forzabili?: boolean;
    DimensioneMinima?: number;
    HeaderVisible?: boolean;
    BodyVisible?: boolean;
    ShowOnlySelected?: boolean;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup: any) => any;
}

export class Prodotti extends BasePureComponent<IProdottiProps> {

    private _Prodotti: DatiRCP.CProdotto[] = [];

    public constructor(props: any) {
        super(props);
        this.OnSetProdottoSelezionato = this.OnSetProdottoSelezionato.bind(this);
        this.OnAggiorna = this.OnAggiorna.bind(this);
    }

    private Inizializza(props: IProdottiProps) {
        this.PopolaValori(props.Value);
    }

    private PopolaValori(valore: Glob.DatiJSON) {
        this._Prodotti = [];
        if (this.props.Value != undefined && this.props.Value != "") {
            //this._Prodotti = JSON.parse(valore);
            let app: DatiRCP.CProdotto[] = [];
            if (typeof (this.props.Value) == "string")
                app = JSON.parse(this.props.Value);
            else
                app = this.props.Value;

            for (let i: number = 0; i < app.length; i++) {
                this._Prodotti.push(Glob.DeserializzaOggettoNuovo(DatiRCP.CProdotto, JSON.stringify(app[i])));
            }
        }
        else {
            this._Prodotti = [];
        }

        //Popolo la cache
        for (var i = 0; i < this._Prodotti.length; i++) {
            this._Prodotti[i].NumeroGaranzieParziali();
            this._Prodotti[i].CalcolaImportoLordoTotale();
        }
        //Ordiniamo i prodotti per prezzo totale
        let swapped: boolean = false;
        do {
            swapped = false;
            for (var i = 0; i < this._Prodotti.length - 1; i++) {
                let condition: boolean = false;
                if (this._Prodotti[i + 1].NumeroGaranzieParzialiCache < this._Prodotti[i].NumeroGaranzieParzialiCache) {
                    condition = true;
                }
                else if (this._Prodotti[i + 1].NumeroGaranzieParzialiCache == this._Prodotti[i].NumeroGaranzieParzialiCache) {
                    condition = this._Prodotti[i + 1].CalcolaImportoLordoTotaleCache < this._Prodotti[i].CalcolaImportoLordoTotaleCache;
                }
                if (condition) {
                    var temp = this._Prodotti[i];
                    this._Prodotti[i] = this._Prodotti[i + 1];
                    this._Prodotti[i + 1] = temp;
                    swapped = true;
                }
            }
        } while (swapped);

        this.InizializzoMigliorPremioPolizzeBase();

        this.InizializzoMigliorPremioPolizzeAccessorie();
    }

    private InizializzoMigliorPremioPolizzeBase() {
        let MinPremio: number = 9999999999999999999999999999;
        let MaxPremio: number = 0;

        for (let i: number = 0; i < this._Prodotti.length; i++) {
            MaxPremio = this.CalcolaPeggiorPremio(this._Prodotti[i].GaranziaBase, MinPremio);
            MinPremio = this.CalcolaMigliorPremio(this._Prodotti[i].GaranziaBase, MinPremio);
        }

        //Applico le etichette per miglior premio ecc
        for (let i: number = 0; i < this._Prodotti.length; i++) {
            this.AssegnaMigliorPremio(this._Prodotti[i].GaranziaBase, MinPremio, MaxPremio);
        }
    }

    private InizializzoMigliorPremioPolizzeAccessorie() {
        if (this._Prodotti.length > 0) {
            for (let i: number = 0; i < this._Prodotti[0].GaranzieAccessorie.length; i++) {
                let MinPremio: number = 9999999999999999999999999999;
                let MaxPremio: number = 0;

                for (let x: number = 0; x < this._Prodotti.length; x++) {
                    MaxPremio = this.CalcolaPeggiorPremio(this._Prodotti[x].GaranzieAccessorie[i], MinPremio);
                    MinPremio = this.CalcolaMigliorPremio(this._Prodotti[x].GaranzieAccessorie[i], MinPremio);
                }

                for (let x: number = 0; x < this._Prodotti.length; x++) {
                    this.AssegnaMigliorPremio(this._Prodotti[x].GaranzieAccessorie[i], MinPremio, MaxPremio);
                }
            }
        }
    }

    private CalcolaMigliorPremio(garanzia: DatiRCP.CGaranzia, minPremio: number): number {
        if (garanzia == undefined)
            garanzia = new DatiRCP.CGaranzia();

        if (garanzia.ImportoLordo < minPremio && garanzia.Abilitata && garanzia.Semaforo == SemaforoVerde) {
            minPremio = garanzia.ImportoLordo;
        }

        return minPremio;
    }

    private CalcolaPeggiorPremio(garanzia: DatiRCP.CGaranzia, maxPremio: number): number {
        if (garanzia == undefined)
            garanzia = new DatiRCP.CGaranzia();

        if (garanzia.ImportoLordo > maxPremio && garanzia.Abilitata) {
            maxPremio = garanzia.ImportoLordo;
        }

        return maxPremio;
    }

    private AssegnaMigliorPremio(garanzia: DatiRCP.CGaranzia, minPremio: number, maxPremio: number) {
        if (garanzia == undefined)
            garanzia = new DatiRCP.CGaranzia();

        if (garanzia.ImportoLordo == minPremio && garanzia.Abilitata) {
            garanzia.MigliorPremio = Glob.PremioMigliore;
        }
        else if (garanzia.ImportoLordo == maxPremio && garanzia.Abilitata) {
            garanzia.MigliorPremio = Glob.PremioPeggiore;
        }
        else {
            garanzia.MigliorPremio = Glob.PremioStandard;
        }
    }

    private EsponiProdotti(): React.ReactNode[] {
        let prodotti: React.ReactNode[] = [];
        let showedProducts: DatiRCP.CProdotto[] = [];
        const { ShowOnlySelected, DimensioneMinima } = this.props;

        showedProducts = this._Prodotti.filter((item) => !ShowOnlySelected || (ShowOnlySelected && item.GaranziaBase.Selezionata));

        let cssProdotto = "";
        switch (showedProducts.length) {
            case 1: {
                cssProdotto = Glob.DimensioneCSS(12);//"col-12 col-sm-12 col-md-12 col-lg-12 col-lx-12"
                break;
            }
            case 2: {
                if (DimensioneMinima == undefined || DimensioneMinima <= 6)
                    cssProdotto = Glob.DimensioneCSS(6);//"col-12 col-sm-12 col-md-12 col-lg-6 col-lx-6"
                else
                    cssProdotto = Glob.DimensioneCSS(DimensioneMinima);
                break;
            }
            case 3: {
                if (DimensioneMinima == undefined || DimensioneMinima <= 4)
                    cssProdotto = Glob.DimensioneCSS(4);//"col-12 col-sm-12 col-md-6 col-lg-4 col-lx-4"
                else
                    cssProdotto = Glob.DimensioneCSS(DimensioneMinima);
                break;
            }
            default: {
                if (DimensioneMinima == undefined || DimensioneMinima <= 4)
                    cssProdotto = Glob.DimensioneCSS(4);//"col-12 col-sm-12 col-md-6 col-lg-3 col-lx-3"
                else
                    cssProdotto = Glob.DimensioneCSS(DimensioneMinima);
                break;
            }
        }

        //console.warn("DIMENSIONE", this.props.DimensioneMinima, this._Prodotti.length, cssProdotto);

        //Garanzie accessorie
        for (let i: number = 0; i < this._Prodotti.length; i++) {
            if (!ShowOnlySelected || (ShowOnlySelected && this._Prodotti[i].GaranziaBase.Selezionata)) {
                prodotti.push(
                    <div key={i} className={cssProdotto}>
                        <Prodotto Id={"Prodotto_" + i} Name={"Prodotto_" + i} OnChange={this.OnAggiorna} OnChangeAppendice={this.props.OnChangeAppendice} Value={JSON.stringify(this._Prodotti[i])} OnSetProdottoSelezionato={this.OnSetProdottoSelezionato} Abilitato={this.props.Abilitato} Forzabile={this.props.Forzabili} NumeroFratelli={this._Prodotti.length} HeaderVisible={this.props.HeaderVisible} BodyVisible={this.props.BodyVisible} ShowOnlySelected={this.props.ShowOnlySelected} />
                    </div>
                );
            }
        }
        return prodotti;
    }

    protected OnSetProdottoSelezionato(compagnia: string): void {
        let GiaSelezionato: boolean = false;
        for (let i: number = 0; i < this._Prodotti.length; i++) {
            if (this._Prodotti[i].Compagnia == compagnia) {
                if (this._Prodotti[i].GaranziaBase.Selezionata) {
                    GiaSelezionato = true;
                }
                this._Prodotti[i].GaranziaBase.Selezionata = true;
            } else {
                this._Prodotti[i].GaranziaBase.Selezionata = false;
            }
        }
        if (!GiaSelezionato) {
            this.props.OnChange(this.props.Name, this._Prodotti);
        }
        this.props.OnChange(this.props.CampoPreventivoSelezionato, true);
    }


    protected OnAggiorna(e: React.FormEvent<any> | string, v: DatiRCP.CProdotto): void {
        if (typeof (e) == "string") {
            for (let i: number = 0; i < this._Prodotti.length; i++) {
                if (this._Prodotti[i].Compagnia == v.Compagnia) {
                    this._Prodotti[i] = v;
                    this.props.OnChange(this.props.Name, this._Prodotti);
                    this.props.OnChange(this.props.CampoPreventivoSelezionato, false);
                }
            }
        }
    }

    public render() {
        this.Inizializza(this.props);

        //console.warn("PRODOTTI", this.props);

        return this.EsponiProdotti();
    }
}


// WEBPACK FOOTER //
// ./src/components/Prodotti.tsx